module.exports = __webpack_public_path__ + "img/bespoke123_02.e1ed50d7.jpg";